var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3134 3.33363C4.31322 3.68726 4.17257 4.02632 3.9224 4.27625C3.67223 4.52617 3.33302 4.66648 2.9794 4.6663C2.62577 4.66612 2.28671 4.52548 2.03678 4.27531C1.78686 4.02513 1.64655 3.68592 1.64673 3.3323C1.64691 2.97868 1.78755 2.63961 2.03772 2.38969C2.2879 2.13976 2.62711 1.99946 2.98073 1.99963C3.33435 1.99981 3.67342 2.14046 3.92334 2.39063C4.17327 2.6408 4.31357 2.98001 4.3134 3.33363ZM4.3534 5.85363C4.3534 5.74318 4.26385 5.65363 4.1534 5.65363H1.88673C1.77627 5.65363 1.68673 5.74318 1.68673 5.85363V13.8003C1.68673 13.9108 1.77627 14.0003 1.88673 14.0003H4.1534C4.26385 14.0003 4.3534 13.9108 4.3534 13.8003V5.85363ZM8.56185 5.85839C8.56453 5.74611 8.47423 5.65363 8.36191 5.65363H6.1134C6.00294 5.65363 5.9134 5.74318 5.9134 5.85363V13.8003C5.9134 13.9108 6.00294 14.0003 6.1134 14.0003H8.34006C8.45052 14.0003 8.54006 13.9108 8.54006 13.8003V9.6203C8.54006 7.1803 11.7201 6.95363 11.7201 9.6203V13.8003C11.7201 13.9108 11.8096 14.0003 11.9201 14.0003H14.1534C14.2639 14.0003 14.3534 13.9108 14.3534 13.8003V8.71363C14.3534 4.6003 9.64673 4.75363 8.54006 6.77363L8.56185 5.85839Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.56677d5e091255a536a4948822eec820.svg";
export { ForwardRef as ReactComponent };